
export default (url_root) => {
  const defName = "vr360Manage"
  const ROUTER_DATA_MANAGE = [
    {
      path: "/manage/vr360",
      name: "vr360Manage",
      meta: {
        title: "Quản lý vr360",
        icon: "ri-settings-3-line",
        name: "Quản lý vr360",
        showMenu: true,
        showNavSubMenu: false,
        belongTo: defName,
        // requiresAuth: true,
        // cpuiaPermission: true,
      },
      props: {
        nameKCN: "Quản lý vr360",
      },
      component: () =>
        import(
          "./pages/ManageVr360.vue"
        ),
    },
    {
      path: "/vr360/:slug",
      name: "vr360Public",
      meta: {
        title: "VR360",
        icon: "ri-settings-3-line",
        name: "Danh sách",
      },
      props: {
        nameKCN: "vr360",
      },
      component: () =>
        import(
          "./pages/VrTourPublic.vue"
        ),
    },
    {
      path: "/vr360",
      name: "listVr360DinhHoa",
      meta: {
        title: "VR360",
        icon: "ri-settings-3-line",
        name: "Danh sách",
      },
      props: {
        nameKCN: "VR360 định hoá",
      },
      component: () =>
        import(
          "./pages/VR360DinhHoa.vue"
        ),
    },
    {
      path: "/vr360-new",
      name: "VRNews",
      meta: { title: "VR360" },
      component: () => import("./pages/VRTourNew.vue"),
    },

  ];

  ROUTER_DATA_MANAGE.map((router) => {
    router.path = url_root ? "/" + url_root + router.path : router.path;
  });
  return ROUTER_DATA_MANAGE;
};
